<template>
	<div :class="'left-menu-'+getColor">
        <div class="left-menuUp">
            <div class="site-name">
                <div class="site-name__text">Iqquantum</div>
                <router-link :to="{name: 'profitability'}">
                    <div v-show="login !== ''" class="site-name__exit" @click="clear">Выход</div>
                </router-link>
                <div v-show="login !== ''" class="site-name__ico" @click="clear">
                    <i class="icon-exit"></i>
                </div>
                </div>
            <div v-if="login !== ''" class="user-info">
            <div class="user-info__name">{{getUserInfo.name}} {{getUserInfo.surname}}</div>
            <div class="user-info__role">Пользователь</div>
                </div>
            <div v-else class="reg-block">
                <input type="button" value="войти" @click="onSign">
                <div class="reg-link" @click="onReg">Регистрация</div>
            </div>
            <div class="menu_wrap">
                <router-link v-for="(item, index) in menuItems"
                    :key="index"
                    :to="item.url"
                    tag="div"
                    :class="'left-item-'+getColor"
                    active-class="left-tem left-item-active">
                    <a>{{ item.text }}</a>
                </router-link>
            </div>
        </div>
        <div class="left-menuDown">
            <div class="left-menuDown_item" :class="'left-item-'+getColor">
                <a target="_blank" href="viber://pa?chatURI=Forexinvest">Подписаться на сигналы в Viber</a>
                <Description :direction = "'left'" :text="'Для подписки на Viber канал необходимо установить на компьютер приложение Viber для компьютера. После подписки, в канал необходимо отправить одно сообщение с любым текстом.'"/>
            </div>
            <div class="left-menuDown_item" :class="'left-item-'+getColor">
                <a target="_blank" href="https://t.me/forexsignals18">Подписаться на сигналы в Telegram</a>
                <Description :direction = "'left'" :text="'Если Вы находитесь в РФ, ссылка на канал будет блокироваться, для открытия ссылки воспользуйтесь VPN соединением'"/>
            </div>
            <div class="left-menuDown_item" :class="'left-item-'+getColor">
                <a target="_blank" href="https://chat.whatsapp.com/INW8gSnWTSDCJmr6dK2yGN">Подписаться на сигналы в WhatsApp</a>
            </div>
        </div>
        <!--<div class="langSwitch">
            {{$t('locale.switchLang')}} <lang-switch />
        </div>-->
    </div>
</template>

<script>
import LangSwitch from '../ui-components/ui-lang-switch';
import Description from '../ui-components/description'
import { mapGetters, mapMutations } from 'vuex';
	export default {
		components: {
            "lang-switch":LangSwitch,
            Description
	    },
		props: [],
		data() {
			return {
                userData: {},
			};
		},
		computed: {
			 ...mapGetters({
                login: 'auth/getLogin',
                Name: 'auth/getName',
                Surname:'auth/getSurname',
                getColor: "color/getColor",
                userInfo: 'auth/getInfoUser'
             }),
			menuItems() {
      			return this.$store.getters['menu/items'];
            },
            getUserInfo () {
                let info = {
                    name:'',
                    surname:''
                }
                if (this.userInfo != null) {
                    info = {
                         name:this.userInfo.Detail.Name,
                         surname:this.userInfo.Detail.Surname
                    }
                }
                else {
                    info = {
                         name:this.Name,
                         surname:this.Surname
                    }
                }
                return info

            }
		},
		methods: {
			onReg(e)
			{
				this.$emit('openReg',true);
            },
            onSign(e)
            {
                this.$emit('openSign',true);
            },
			clear()
			{
                this.$store.dispatch('auth/clearUserInfo');
                localStorage.removeItem('infoUser');
                this.$store.dispatch('chat/logout');
                this.$store.dispatch('chat/connectWithCreds', {
				    login: 'unname',
				    password: 'MSLAATbzX4vxAorjq'
                });
			}
        },
        created() {
            this.userData = this.$store.getters['auth/getInfoUser']
        }

	};
</script>

<style lang="less" scoped>
.left-menuDown {
    &_item {
        padding: 8px 0px 8px 0px;
        max-height: 46px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        a {
            display: block;
            height: 30px;
            margin-right: 12px;
        }
    }
}
.menu_wrap {
    margin-top: 8px;
}
.left-menu-black
{
	width: 332px;
	height: 100vh;
	background: #fff;
	z-index: 999;
	position: absolute;
	left: 71px;
	background-color: #374b62;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
	top: 0;
}

.left-menu-white
{
	width: 332px;
	height: 100vh;
	background: #fff;
	z-index: 999;
	position: absolute;
	left: 71px;
	background-color: #fff;
	display: block;
	top: 0;
}

.left-item {
  padding: 0 0 0 16px;

   &:last-child a
  {
	  color:@colors[green];
  }
}

.left-item-black a {
  font-family: Montserrat;
  font-size: 13px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  height: 33px;
  display: flex;
  align-items: center;
  letter-spacing: 0.4px;
  text-align: left;
  color: #cae9ff;
  cursor: pointer;
  text-decoration: none;
}

.left-item-white a {
  font-family: Montserrat;
  font-size: 13px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  height: 33px;
  display: flex;
  align-items: center;
  letter-spacing: 0.4px;
  text-align: left;
  color: #999999;
  cursor: pointer;
  text-decoration: none;
}

.left-item-active {
  background-color: #cae9ff;
}
.left-item-active a {
  color: #324258 !important;
}


.site-name
{
    padding: 0px 24px 0px 16px;
    height: 70px;
    align-items: center;
    display: flex;
    box-sizing: border-box;

    &__text
    {
        font-family: Montserrat;
        font-size: 24px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: normal;
        text-transform: uppercase;
        color: #e1ff3f;
        margin-right: 27px;
        max-height: 32px;
    }

    &__exit
    {
        font-family: Montserrat;
        font-size: 15px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: normal;
        color: #adc4e1;
        align-self: center;
        justify-items: flex-end;
        margin-right: 12px;
        cursor:pointer;
    }

    &__ico
    {
        font-size: 20px;
        color:#adc4e1;
        display: flex;
        align-items: center;
        padding-top: 3px;
    }

}

.user-info
{
    padding: 14px 0 16px 12px;
    height: 70px;
    box-sizing: border-box;
    &__name
    {
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: 0.4px;
        color: #cae9ff;
    }

    &__role
    {
        font-family: Montserrat;
        font-size: 12px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: 0.4px;
        color: #718da8;
    }
}

input[type="button"] {
width: 115px;
height: 48px;
border-radius: 4px;
background-color: #0fd7b7;
border: none;
margin-top: 11px;
margin-right: 36px;
color: #374b62;
cursor: pointer;
font-family: Arimo;
font-size: 13px;
font-weight: bold;
}

.reg-block
{
	display: flex;
	padding-left: 16px;
    padding-bottom: 10px;
    height: 70px;
    box-sizing: border-box;
}

.reg-link
{
  height: 48px;
  font-family: Arimo;
  font-size: 13px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: 0.4px;
  text-align: center;
  color: @colors[green];
  margin-top:11px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  cursor: pointer;
}

</style>
